export default __webpack_public_path__ + "static/media/leasing.970601fd.svg";